import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Button } from "react-bootstrap";
import Header from "./Header.js";
import Sidebar from "./Sidebar.js";
//  import DataGridTable from "./common/DataGridTable";
import DynamicTable from "./common/DynamicTable.js";
import DynamicTiles from "./common/DynamicTiles.js";
import http from "../api/server.js";
import Footer from "./Footer.js";
import BottomBarIcons from "./BottomBarIcons.js";
import { GET_INSPECTION_DATA_SUMMARY_BY_CLIENT_ID } from "../api/apiPath.js";
import SidebarIcons from "./SidebarIcons.js";
import { useSelector } from "react-redux";
import { useNavigate, generatePath, useParams } from "react-router-dom";
import LoadingComponent from "./common/LoadingComponent";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton } from "@mui/material";
import useGetClientId from "../hooks/useGetClientId";
import StatusPill from "./common/StatusPill.js";
import { Statuses } from "./common/constant";

import propertyIcon from "../assets/img/newprop1.png";
import usericon from "../assets/img/newusers.png";
import inspectionicon from "../assets/img/createInsps.png";
import leadicon from "../assets/img/ticket.png";
import ongoingicon from "../assets/img/ongoinIns.png";
// import reporticon from "../assets/img/report.png";
import AutocompleteInput from "./common/AutocompleteInput";
import searchIcon from "../assets/img/searchIcon.png";
// import { Statuses } from "./common/constant.js";
// import statsBground from "../assets/img/statsBground.png"

const AdminDashboard = () => {
  const { userObj } = useSelector((state) => state.user);
  const { clientNameParam } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [searchTextProgress, setSearchTextProgress] = useState("");
  const [searchTextCompleted, setSearchTextCompleted] = useState("");
  const [propertyNameProgress, setPropertyNameProgress] =
    useState("Property Name");
  const [buildingNameProgress, setBuildingNameProgress] =
    useState("Building Name");
  const [buildingNameCompleted, setBuildingNameCompleted] =
    useState("Building Name");

  const [propertyNameCompleted, setPropertyNameCompleted] =
    useState("Property Name");
  const [InspectorProgress, setInspectorProgress] = useState("Inspector");
  const [InspectorCompleted, setInspectorCompleted] = useState("Inspector");
  const [statusProgress, setStatusProgress] = useState("Status");
  const [statusCompleted, setStatusCompleted] = useState("Status");
  const [date, setDate] = useState("Date");
  const [hideSidebar, setHideSidebar] = useState(false);
  const [progressSurveyData, setProgressSurveyData] = useState([]);
  const [completedSurveyData, setCompletedSurveyData] = useState([]);
  const [loading, setLoading] = useState(true);

  const clientObj = useGetClientId();

  const isAnyFilterAppliedOnProgress =
    searchTextProgress !== "" ||
    propertyNameProgress !== "Property Name" ||
    buildingNameProgress !== "Building Name" ||
    InspectorProgress !== "Inspector" ||
    statusProgress !== "Status";

  const isAnyFilterAppliedOnCompleted =
    searchTextCompleted !== "" ||
    propertyNameCompleted !== "Property Name" ||
    buildingNameCompleted !== "Building Name" ||
    InspectorCompleted !== "Inspector" ||
    statusCompleted !== "Status" ||
    date !== "Date";

  const toCalendarDay = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return "";
    const y = d.getUTCFullYear();
    const m = String(d.getUTCMonth() + 1).padStart(2, "0");
    const day = String(d.getUTCDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  useEffect(() => {
    if (clientObj.clientId) {
      fetchData();
    }
  }, [clientObj.clientId, clientObj.loading]);

  const fetchData = async () => {
    try {
      const response = await http.get(
        GET_INSPECTION_DATA_SUMMARY_BY_CLIENT_ID +
          clientObj?.clientId +
          "&userId=" +
          userObj?.userId,
      ); //"E54D74F7-3367-4286-87AC-DD70C94B7B3E"
      if (response?.data) {
        setData(response?.data);
        // setProgressSurveyData(response?.data?.propertyFields);
        // setCompletedSurveyData(response?.data?.propertyFields);
        if (response?.data?.propertyFields) {
          const tempProgress = response?.data?.propertyFields;
          tempProgress?.forEach((item) => {
            item.id = item.inspectionReferenceNumber; // Assigning a sequential ID
          });

          setProgressSurveyData(
            tempProgress?.filter(
              (item) =>
                item.status !== "Completed" && item.status !== "Rejected",
            ),
          );
          setCompletedSurveyData(
            tempProgress?.filter((item) => item.status === "Completed"),
          );
          setLoading(false);
        }
      }
    } catch (error) {
      console.error("Error fetching contact count:", error);
    }
  };

  const getProgressSurveyColumn = () => [
    {
      field: "propertyName",
      headerName: "SITE NAME",
      headerClassName: "header-bold super-app-theme--header",
      sortable: false,
      flex: 0.8,
      renderCell: (data) => {
        return (
          <>
            <span
              onClick={() => {
                if (!userObj?.isAdmin) return;

                const path = generatePath(
                  "/client/:clientNameParam/viewSite/:propertyMasterId",
                  {
                    clientNameParam,
                    propertyMasterId: data?.row?.propertyMasterId,
                  },
                );
                navigate(path);
              }}
              style={{
                cursor: "pointer",
                alignItems: "anchor-center",
                display: "inline-flex",
              }}
            >
              {data?.row?.propertyName}{" "}
              {data.row.isOverDue &&
                data.row.status !== Statuses.CANCELLED &&
                data.row.status !== Statuses.COMPLETED && (
                  <i
                    className="bi bi-info-circle"
                    style={{
                      fontSize: "0.9rem",
                      marginLeft: "5px",
                      cursor: "pointer",
                    }}
                    title="This inspection is overdue."
                  ></i>
                )}
            </span>
          </>
        );
      },
    },
    {
      field: "buildingName",
      headerName: "BUILDING NAME",
      headerClassName: "header-bold super-app-theme--header",
      sortable: false,
      flex: 1,
      renderCell: (data) => {
        return (
          <span
            onClick={() => {
              if (!userObj?.isAdmin) return;

              const path = generatePath(
                "/client/:clientNameParam/viewSite/:propertyMasterId",
                {
                  clientNameParam,
                  propertyMasterId: data?.row?.propertyMasterId,
                },
              );
              navigate(path);
            }}
            style={{ cursor: "pointer" }}
          >
            {data?.row?.buildingName}
          </span>
        );
      },
    },
    {
      field: "inspectedBy",
      headerName: "INSPECTOR",
      flex: 1,
      headerClassName: "header-bold super-app-theme--header",
    },

    {
      field: "status",
      headerName: "STATUS",
      flex: 1,
      headerClassName: "header-bold super-app-theme--header",
      renderCell: (params) => {
        const status = params.value;
        return <StatusPill status={status} row={params.row} />;
      },
    },
  ];

  const getCompletedSurveyColumn = () => [
    {
      field: "propertyName",
      headerName: "SITE NAME",
      headerClassName: "header-bold super-app-theme--header",
      sortable: false,
      flex: 0.3,
      renderCell: (data) => {
        return (
          <span
            onClick={() => {
              if (!userObj?.isAdmin) return;

              const path = generatePath(
                "/client/:clientNameParam/viewSite/:propertyMasterId",
                {
                  clientNameParam,
                  propertyMasterId: data?.row?.propertyMasterId,
                },
              );
              navigate(path);
            }}
            style={{ cursor: "pointer" }}
          >
            {data?.row?.propertyName}
          </span>
        );
      },
    },
    {
      field: "buildingName",
      headerName: "BUILDING NAME",
      headerClassName: "header-bold super-app-theme--header",
      sortable: false,
      flex: 0.3,
      renderCell: (data) => {
        return (
          <span
            onClick={() => {
              if (!userObj?.isAdmin) return;

              const path = generatePath(
                "/client/:clientNameParam/viewSite/:propertyMasterId",
                {
                  clientNameParam,
                  propertyMasterId: data?.row?.propertyMasterId,
                },
              );
              navigate(path);
            }}
            style={{ cursor: "pointer" }}
          >
            {data?.row?.buildingName}
          </span>
        );
      },
    },
    {
      field: "inspectedBy",
      headerName: "INSPECTOR",
      flex: 0.4,
      headerClassName: "header-bold super-app-theme--header",
    },

    {
      field: "lastInspectionDate",
      headerName: "Date",
      flex: 0.3,
      headerClassName: "header-bold super-app-theme--header",
      renderCell: (params) => {
        const rawDate = params.value;
        if (!rawDate) return "";

        const dateObj = new Date(rawDate);
        const formattedDate = dateObj.toLocaleDateString("en-GB"); // DD/MM/YYYY format

        return <span>{formattedDate}</span>;
      },
    },

    {
      field: "status",
      headerName: "STATUS",
      flex: 0.5,
      headerClassName: "header-bold super-app-theme--header",
      renderCell: (params) => {
        const status = params.value;
        // const styles = {
        //   padding: "4px 12px",
        //   borderRadius: "12px",
        //   fontSize: "0.85rem",
        //   color: "#333",
        //   backgroundColor:
        //     status === "Completed"
        //       ? "#C8E6C9"
        //       : status === "Scheduled"
        //       ? "#BBDEFB"
        //       : "#FFE0B2",
        // };

        // return <span style={styles}>{status}</span>;
        return <StatusPill status={status} row={params.row} />;
      },
    },
  ];
  // 🔹 PROGRESS
  const propertyNameProgressList = [
    ...new Set(
      progressSurveyData.map((item) => item.propertyName).filter(Boolean),
    ),
  ].map((item) => ({ name: item }));

  const buildingNameProgressList = [
    ...new Map(
      progressSurveyData
        ?.filter((item) =>
          propertyNameProgress !== "Property Name"
            ? item.propertyName === propertyNameProgress
            : true,
        )
        .map((item) => [item.buildingName, { name: item.buildingName }]) || [],
    ).values(),
  ].filter((item) => item.name);

  const inspectorProgressList = [
    ...new Set(
      progressSurveyData.map((item) => item.inspectedBy).filter(Boolean),
    ),
  ].map((item) => ({ name: item }));

  const propertyNameCompletedList = [
    ...new Set(
      completedSurveyData
        .map((item) => item.propertyName?.trim())
        .filter(Boolean),
    ),
  ].map((item) => ({ name: item }));

  const buildingNameCompletedList = [
    ...new Map(
      completedSurveyData
        ?.filter((item) =>
          propertyNameCompleted !== "Property Name"
            ? item.propertyName === propertyNameCompleted
            : true,
        )
        .map((item) => [item.buildingName, { name: item.buildingName }]) || [],
    ).values(),
  ].filter((item) => item.name);

  const inspectorCompletedList = [
    ...new Set(
      completedSurveyData.map((item) => item.inspectedBy).filter(Boolean),
    ),
  ].map((item) => ({ name: item }));

  const filteredRowsProgress = progressSurveyData.filter((row) => {
    const matchesSearch =
      !searchTextProgress ||
      row.propertyName
        ?.toLowerCase()
        .includes(searchTextProgress.toLowerCase()) ||
      row.status?.toLowerCase().includes(searchTextProgress.toLowerCase()) ||
      row.inspectedBy?.toLowerCase().includes(searchTextProgress.toLowerCase());

    const matchesPropertyNameProgress =
      propertyNameProgress === "Property Name" ||
      row.propertyName === propertyNameProgress;

    const matchesBuildingNameProgress =
      buildingNameProgress === "Building Name" ||
      row.buildingName === buildingNameProgress;

    const matchesInspector =
      InspectorProgress === "Inspector" ||
      row.inspectedBy === InspectorProgress;

    const matchesStatus =
          statusProgress === "Status" ||
          (statusProgress !== "Overdue" && row.status === statusProgress) ||
          (statusProgress === "Overdue" && row.isOverDue === true);

    return (
      matchesSearch &&
      matchesPropertyNameProgress &&
      matchesInspector &&
      matchesStatus &&
      matchesBuildingNameProgress
    );
  });
  const filteredRowsCompleted = completedSurveyData.filter((row) => {
    const matchesSearch =
      !searchTextCompleted ||
      row.propertyName
        ?.toLowerCase()
        .includes(searchTextCompleted.toLowerCase()) ||
      row.status?.toLowerCase().includes(searchTextCompleted.toLowerCase()) ||
      row.lastInspectionDate
        ?.toLowerCase()
        .includes(searchTextCompleted.toLowerCase()) ||
      row.inspectedBy
        ?.toLowerCase()
        .includes(searchTextCompleted.toLowerCase());

    const matchesPropertyNameCompleted =
      propertyNameCompleted === "Property Name" ||
      (row.propertyName?.trim() ?? "") ===
        (propertyNameCompleted?.trim() ?? "");

    const matchesBuildingNameCompleted =
      buildingNameCompleted === "Building Name" ||
      (row.buildingName?.trim() ?? "") ===
        (buildingNameCompleted?.trim() ?? "");

    const inspectorList =
      row.inspectedBy
        ?.split(",")
        .map((s) => s.trim())
        .filter(Boolean) ?? [];
    const selectedInspector = InspectorCompleted?.trim() ?? "";
    const rowInspectedByTrimmed = row.inspectedBy?.trim() ?? "";
    const matchesInspector =
      InspectorCompleted === "Inspector" ||
      selectedInspector === "" ||
      inspectorList.some(
        (name) => (name?.trim() ?? "") === selectedInspector,
      ) ||
      rowInspectedByTrimmed === selectedInspector;

    const matchesStatus =
      statusCompleted === "Status" || row.status === statusCompleted;
    const matchDate =
      date === "Date" ||
      (row.lastInspectionDate &&
        toCalendarDay(row.lastInspectionDate) === date);

    return (
      matchesSearch &&
      matchesPropertyNameCompleted &&
      matchesInspector &&
      matchesStatus &&
      matchDate &&
      matchesBuildingNameCompleted
    );
  });

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      <LoadingComponent loading={loading} />
      <div className="dashboard_body_main">
        {/* Header */}

        {hideSidebar ? (
          <Sidebar setHideSidebar={setHideSidebar} hideSidebar={hideSidebar} />
        ) : (
          <SidebarIcons
            setHideSidebar={setHideSidebar}
            hideSidebar={hideSidebar}
          />
        )}
        <div
          className="d-flex dashboard_body flex-column py-1 w-100 mt-2"
          //style={{ marginTop: "123px !important", marginBottom: "75px" }} //paddingLeft: "120px", paddingRight: "50px" }}
        >
          {/* Stats Cards */}
          <Row className="mb-3">
            <Col md={true} sm={6} xs={12}>
              <div
                className="p-2 bg-white text-center"
                style={{ border: "1px solid #D4D4D4", borderRadius: "10px" }}
              >
                <span style={{ fontSize: "2.8rem", fontWeight: "600" }}>
                  {data?.adminApproverTotalInspections?.totalAvailablePoints ||
                    0}
                </span>
                <p className="mb-0" style={{ fontWeight: "600" }}>
                  TOTAL CREDITS
                </p>
              </div>
            </Col>

            <Col md={true} sm={6} xs={12}>
              <div
                className="p-2 bg-white  text-center"
                style={{ border: "1px solid #D4D4D4", borderRadius: "10px" }}
              >
                <span style={{ fontSize: "2.8rem", fontWeight: "600" }}>
                  {data?.adminDashboardInfos?.totalProperties || 0}
                </span>
                <p className="mb-0" style={{ fontWeight: "600" }}>
                  PROPERTIES ONBOARDED
                </p>
              </div>
            </Col>

            <Col md={true} sm={6} xs={12}>
              <div
                className="p-2 bg-white text-center"
                style={{ border: "1px solid #D4D4D4", borderRadius: "10px" }}
              >
                <span style={{ fontSize: "2.8rem", fontWeight: "600" }}>
                  {data?.adminDashboardInfos?.totalSurveyInProgress || 0}
                </span>
                <p className="mb-0" style={{ fontWeight: "600" }}>
                  SURVEYS IN PROGRESS
                </p>
              </div>
            </Col>
            <Col md={true} sm={6} xs={12}>
              <div
                className="p-2 bg-white text-center"
                style={{ border: "1px solid #D4D4D4", borderRadius: "10px" }}
              >
                <span style={{ fontSize: "2.8rem", fontWeight: "600" }}>
                  {data?.adminDashboardInfos?.totalSurveysCompleted || 0}
                </span>
                <p className="mb-0" style={{ fontWeight: "600" }}>
                  SURVEYS COMPLETED
                </p>
              </div>
            </Col>
            <Col md={true} sm={6} xs={12}>
              <div
                className="p-2 bg-white text-center"
                style={{ border: "1px solid #D4D4D4", borderRadius: "10px" }}
              >
                <span style={{ fontSize: "2.8rem", fontWeight: "600" }}>
                  {data?.adminDashboardInfos?.totalInspectors || 0}
                </span>
                <p className="mb-0" style={{ fontWeight: "600" }}>
                  INSPECTORS
                </p>
              </div>
            </Col>
          </Row>
          <div
            className="p-3 rounded-4 orange-box"
            // style={{
            //   backgroundImage: `url(${statsBground})`,
            //   boxShadow: "0px 20px 25px -5px #0000001A",
            //   backgroundRepeat:'no-repeat',
            //   backgroundPositionY: 'center',
            //   opacity: '90%',
            //   backgroundSize: 'auto'
            // }}
          >
            <Row className="g-3">
              {/* Generate Letter */}
              <Col>
                <div className="d-flex flex-column align-items-center text-center p-2 justify-content-center rounded-3 h-100 property-card">
                  {/* <i
                    className="fa-solid fa-house-circle-check mb-3 vividOrangeColor"
                    style={{ fontSize: "40px" }}
                  /> */}
                  <img
                    src={propertyIcon}
                    style={{ height: "38px" }}
                    className="mb-3"
                    alt="Manage Property"
                  />
                  <h6 className="text-black fw-semibold">Manage Property</h6>
                  <Button
                    className="px-4 fw-semibold mt-3 red-button"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      navigate(
                        generatePath("/client/:clientNameParam/siteDashboard", {
                          clientNameParam,
                        }),
                      );
                    }}
                  >
                    Manage Property
                  </Button>
                </div>
              </Col>
              <Col>
                <div className="d-flex flex-column align-items-center text-center p-2 justify-content-center rounded-3 h-100 property-card">
                  {/* <i
                    className="fa-solid fa-user-plus mb-3 vividOrangeColor"
                    style={{ fontSize: "40px" }}
                  /> */}
                  <img
                    src={usericon}
                    style={{ height: "38px" }}
                    className="mb-3"
                    alt="Manage User"
                  />
                  <h6 className="text-black fw-semibold">Manage User</h6>
                  <Button
                    className="px-4 fw-semibold mt-3 red-button"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      navigate(
                        generatePath("/client/:clientNameParam/members", {
                          clientNameParam,
                        }),
                      );
                    }}
                  >
                    Manage User
                  </Button>
                </div>
              </Col>

              <Col>
                <div className="d-flex flex-column align-items-center text-center p-2 justify-content-center rounded-3 h-100 property-card">
                  {/* <i
                    className="fa-solid fa-user-plus mb-3 vividOrangeColor"
                    style={{ fontSize: "40px" }}
                  /> */}
                  <img
                    src={ongoingicon}
                    style={{ height: "38px" }}
                    className="mb-3"
                    alt="Manage User"
                  />
                  <h6 className="text-black fw-semibold">
                    Ongoing Inspections
                  </h6>
                  <Button
                    className="px-3 fw-semibold mt-3 red-button"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      navigate(
                        generatePath("/client/:clientNameParam/property-form", {
                          clientNameParam,
                        }),
                      );
                    }}
                  >
                    Ongoing Inspections
                  </Button>
                </div>
              </Col>
              {/* <Col>
                <div className="d-flex flex-column align-items-center text-center p-2 justify-content-center rounded-3 h-100 property-card">
                  <i
                    className="fa-solid fa-chart-column mb-3 vividOrangeColor"
                    style={{ fontSize: "40px" }}
                  />
                  <img
                    src={reporticon}
                    style={{ height: "38px" }}
                    className="mb-3"
                    alt="Reports"
                  />
                  <h6 className="text-black fw-semibold">Reports</h6>

                  <Button
                    className="px-4 fw-semibold btn-danger mt-3 red-button"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      // Handle report generation
                    }}
                  >
                    Reports
                  </Button>
                </div>
              </Col> */}
              <Col>
                <div className="d-flex flex-column align-items-center text-center p-2 justify-content-center rounded-3 h-100 property-card">
                  {/* <i
                    className="fa-regular fa-clipboard mb-3 vividOrangeColor"
                    style={{ fontSize: "40px" }}
                  /> */}
                  <img
                    src={inspectionicon}
                    style={{ height: "38px" }}
                    className="mb-3"
                    alt="Manage inspection"
                  />
                  <h6 className="text-black fw-semibold">Manage Inspection</h6>
                  <Button
                    className="fw-semibold mt-3 red-button"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      navigate(
                        generatePath(
                          "/client/:clientNameParam/inspectionDashboard",
                          {
                            clientNameParam,
                          },
                        ),
                      );
                    }}
                  >
                    Manage Inspection
                  </Button>
                </div>
              </Col>
              <Col>
                <div className="d-flex flex-column align-items-center text-center p-2 justify-content-center rounded-3 h-100 property-card">
                  {/* <i
                    className="fa-solid fa-ticket mb-3 vividOrangeColor"
                    style={{ fontSize: "40px" }}
                  /> */}
                  <img
                    src={leadicon}
                    style={{ height: "38px" }}
                    className="mb-3 mt-2"
                    alt="Manade leads"
                  />
                  <h6 className="text-black fw-semibold">Manage Leads</h6>
                  <Button
                    className="px-4 fw-semibold mt-3 red-button"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      navigate(
                        generatePath("/client/:clientNameParam/leadDashboard", {
                          clientNameParam,
                        }),
                      );
                    }}
                  >
                    Manage Leads
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          <Row>
            <Col md={6}>
              <div className="dashboard-bar py-3">
                <h2 className="mt-0 mb-3 text-start fw-bold">
                  Survey Progress
                </h2>
                <div className="row align-items-center g-3 mt-1">
                  <div className="row" style={{ marginLeft: "-15px" }}>
                    <div className="custom_toolbar_search col-md-8">
                      <img src={searchIcon} style={{ left: "1.2rem" }} />
                      <input
                        type="text"
                        className="form-control custom_toolbar_control"
                        id="floatingInput"
                        placeholder="Search..."
                        value={searchTextProgress}
                        onChange={(e) => setSearchTextProgress(e.target.value)}
                      />
                    </div>
                    <div className="col-6 col-md-4">
                      <AutocompleteInput
                        masterList={propertyNameProgressList}
                        getOptionLabel={(item) => item?.name || ""}
                        getOptionValue={(item) => item?.name || ""}
                        value={
                          propertyNameProgress === "Property Name"
                            ? ""
                            : propertyNameProgress
                        }
                        onValueChange={(value) =>
                          setPropertyNameProgress(value || "Property Name")
                        }
                        placeholder="Site Name"
                        inputClassName="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-6 col-md-4">
                    <AutocompleteInput
                      masterList={buildingNameProgressList}
                      getOptionLabel={(item) => item?.name || ""}
                      getOptionValue={(item) => item?.name || ""}
                      value={
                        buildingNameProgress === "Building Name"
                          ? ""
                          : buildingNameProgress
                      }
                      onValueChange={(value) =>
                        setBuildingNameProgress(value || "Building Name")
                      }
                      placeholder="Building Name"
                      inputClassName="form-control"
                    />
                  </div>

                  <div className="col-6 col-md-3">
                    {/* <select
                      className="form-select form-control"
                      value={InspectorProgress}
                      onChange={(e) => setInspectorProgress(e.target.value)}
                    >
                      <option value="Inspector">Inspector</option>
                      {[
                        ...new Set(
                          progressSurveyData.map((user) => user.inspectedBy)
                        ),
                      ].map((inspectorItem, index) => (
                        <option key={index} value={inspectorItem}>
                          {inspectorItem}
                        </option>
                      ))}
                    </select> */}
                    <AutocompleteInput
                      masterList={inspectorProgressList}
                      getOptionLabel={(item) => item?.name || ""}
                      getOptionValue={(item) => item?.name || ""}
                      value={
                        InspectorProgress === "Inspector"
                          ? ""
                          : InspectorProgress
                      }
                      onValueChange={(value) =>
                        setInspectorProgress(value || "Inspector")
                      }
                      placeholder="Inspector(s)"
                      inputClassName="form-control"
                    />
                  </div>

                  <div className="col-6 col-md-3" style={{ width: "30.99%" }}>
                    <select
                      className="form-select form-control status-dropdown "
                      value={statusProgress}
                      onChange={(e) => setStatusProgress(e.target.value)}
                    >
                      <option value="Status">Status</option>
                      {progressSurveyData && [
                        ...new Set([
                          ...progressSurveyData.map((user) => user.status),
                          "Overdue"
                      ]),
                      ].sort((a, b) => a.localeCompare(b)).map((statusItem, index) => (
                        <option key={index} value={statusItem}>
                          {statusItem}
                        </option>
                      ))}
                    </select>
                  </div>

                  {isAnyFilterAppliedOnProgress && (
                    <div style={{ width: "auto", paddingLeft: "0px" }}>
                      <IconButton
                        tabIndex={0}
                        title="Clear Filters"
                        onClick={() => {
                          setSearchTextProgress("");
                          setPropertyNameProgress("Property Name");
                          setInspectorProgress("Inspector");
                          setStatusProgress("Status");
                          setBuildingNameProgress("Building Name");
                        }}
                      >
                        <ClearIcon sx={{ color: "#717186" }} fontSize="small" />
                      </IconButton>
                    </div>
                  )}
                </div>
              </div>
              <div className="inspection-table">
                <DynamicTable
                  tableData={filteredRowsProgress}
                  columnsValue={getProgressSurveyColumn()}
                  showSelectAll={false}
                  //handleCheckBoxSelection={handleMultipleUserDelete}
                  pageSize={10}
                  rowHeight={50}
                  pageSizeOptions={[100, 150, 200, { value: -1, label: "All" }]}
                  module="AdminInProgress"
                />
              </div>
              <div className="inspection-tile">
                {filteredRowsProgress &&
                  filteredRowsProgress?.map((item) => {
                    return (
                      // eslint-disable-next-line react/jsx-key
                      <DynamicTiles
                        tableData={item}
                        module="adminDashboardProgress"
                      />
                    );
                  })}
              </div>
            </Col>
            <Col md={6}>
              <div className="dashboard-bar py-3">
                <h2 className="mt-0 mb-3 text-start fw-bold">
                  Survey Completed
                </h2>
                <div className="row align-items-center g-3 mt-1">
                  {/* Search Bar */}
                  <div className="row" style={{ marginLeft: "-15px" }}>
                    <div className="custom_toolbar_search col-md-8 ">
                      <img src={searchIcon} style={{ left: "1.2rem" }} />
                      <input
                        type="text"
                        className="form-control custom_toolbar_control"
                        id="floatingInput"
                        placeholder="Search..."
                        value={searchTextCompleted}
                        onChange={(e) => setSearchTextCompleted(e.target.value)}
                      />
                    </div>
                    <div className="col-6 col-md-4">
                      <AutocompleteInput
                        masterList={propertyNameCompletedList}
                        getOptionLabel={(item) => item?.name || ""}
                        getOptionValue={(item) => item?.name || ""}
                        value={
                          propertyNameCompleted === "Property Name"
                            ? ""
                            : propertyNameCompleted
                        }
                        onValueChange={(value) =>
                          setPropertyNameCompleted(
                            value?.trim() || "Property Name",
                          )
                        }
                        placeholder="Site Name"
                        inputClassName="form-control"
                      />
                    </div>
                  </div>

                  {/* Dropdowns */}
                  <div className="col-6 col-md-4">
                    <AutocompleteInput
                      masterList={buildingNameCompletedList}
                      getOptionLabel={(item) => item?.name || ""}
                      getOptionValue={(item) => item?.name || ""}
                      value={
                        buildingNameCompleted === "Building Name"
                          ? ""
                          : buildingNameCompleted
                      }
                      onValueChange={(value) =>
                        setBuildingNameCompleted(
                          value?.trim() || "Building Name",
                        )
                      }
                      placeholder="Building Name"
                      inputClassName="form-control"
                    />
                  </div>

                  <div className="col-6 col-md-3">
                    {/* <select
                      className="form-select form-control"
                      value={InspectorCompleted}
                      onChange={(e) => setInspectorCompleted(e.target.value)}
                    >
                      <option value="Inspector">Inspector</option>
                      {[
                        ...new Set(
                          completedSurveyData
                            .map((user) => user.inspectedBy)
                            .filter(Boolean),
                        ),
                      ].map((inspectorItem, index) => (
                        <option key={index} value={inspectorItem}>
                          {inspectorItem}
                        </option>
                      ))}
                    </select> */}

                    <AutocompleteInput
                      masterList={inspectorCompletedList}
                      getOptionLabel={(item) => item?.name || ""}
                      getOptionValue={(item) => item?.name || ""}
                      value={
                        InspectorCompleted === "Inspector"
                          ? ""
                          : InspectorCompleted
                      }
                      onValueChange={(value) =>
                        setInspectorCompleted(value || "Inspector")
                      }
                      placeholder="Inspector(s)"
                      inputClassName="form-control"
                    />
                  </div>
                  <div className="col-6 col-md-2">
                    <select
                      className="form-select form-control status-dropdown"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                    >
                      <option value="Date">Date</option>
                      {Array.from(
                        new Map(
                          completedSurveyData
                            .map((user) => user.lastInspectionDate)
                            .filter(Boolean)
                            .map((dateItem) => {
                              const day = toCalendarDay(dateItem);
                              if (!day) return null;
                              const dateObj = new Date(dateItem);
                              const label = dateObj.toLocaleDateString("en-GB");
                              return [day, label];
                            })
                            .filter(Boolean),
                        ).entries(),
                      ).map(([value, label], index) => (
                        <option key={index} value={value}>
                          {label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6 col-md-3" style={{ width: "17.99%" }}>
                    <select
                      className="form-select form-control status-dropdown"
                      value={statusCompleted}
                      onChange={(e) => setStatusCompleted(e.target.value)}
                    >
                      <option value="Status">Status</option>
                      {[
                        ...new Set(
                          completedSurveyData
                            .map((user) => user.status)
                            .filter(Boolean),
                        ),
                      ].map((statusItem, index) => (
                        <option key={index} value={statusItem}>
                          {statusItem}
                        </option>
                      ))}
                    </select>
                  </div>
                  {isAnyFilterAppliedOnCompleted && (
                    <div style={{ width: "auto", paddingLeft: "0px" }}>
                      <IconButton
                        tabIndex={0}
                        title="Clear Filters"
                        onClick={() => {
                          setSearchTextCompleted("");
                          setPropertyNameCompleted("Property Name");
                          setInspectorCompleted("Inspector");
                          setStatusCompleted("Status");
                          setDate("Date");
                          setBuildingNameCompleted("Building Name");
                        }}
                      >
                        <ClearIcon sx={{ color: "#717186" }} fontSize="small" />
                      </IconButton>
                    </div>
                  )}
                </div>
              </div>
              <div className="inspection-table">
                <DynamicTable
                  key={`survey-completed-${filteredRowsCompleted?.length ?? 0}-${propertyNameCompleted}-${InspectorCompleted}-${statusCompleted}-${date}-${searchTextCompleted}`}
                  tableData={filteredRowsCompleted}
                  columnsValue={getCompletedSurveyColumn()}
                  showSelectAll={false}
                  rowHeight={50}
                  //handleCheckBoxSelection={handleMultipleUserDelete}
                  pageSize={10}
                  pageSizeOptions={[100, 150, 200, { value: -1, label: "All" }]}
                />
              </div>
              <div className="inspection-tile">
                {filteredRowsCompleted &&
                  filteredRowsCompleted?.map((item) => {
                    return (
                      // eslint-disable-next-line react/jsx-key
                      <DynamicTiles
                        tableData={item}
                        module="adminDashboardCompleted"
                      />
                    );
                  })}
              </div>
            </Col>
          </Row>
        </div>
        <Footer />
        <div className="bottom-bar-spacing"></div>
        <BottomBarIcons />
      </div>
    </>
  );
};
export default AdminDashboard;
